<template>
    <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
            <div class="p-5">
                <div
                    class="
                        d-flex
                        justify-content-between
                        align-items-center
                        mb-5
                    "
                >
                    <div class="c-title">Edit Campaign</div>
                    <div class="ml-auto">
                        <button
                            @click="goToViewCampaign"
                            class="btn c-cancel-btn"
                        >
                            Cancel
                        </button>
                    </div>
                    <button type="submit" class="btn ml-3 c-save-btn">
                        Save
                    </button>
                </div>

                <div class="row" v-if="campaign">
                    <div class="col-sm-12 col-md-7">
                        <SelectField
                            v-model="form.type"
                            name="type"
                            label="Type"
                            :options="types"
                            :has-icon="true"
                        >
                            <template #append-icon>
                                <a @click.prevent="() => {}">
                                    <i
                                        class="fa fa-chevron-circle-down mt-2"
                                        style="font-size: 20px; color: #40b8dc"
                                    />
                                </a>
                            </template>
                        </SelectField>
                        <TextField
                            v-model="form.title"
                            name="title"
                            label="Title"
                            rules="required"
                        />
                        <div v-if="parseInt(form.type) === 3">
                            <div class="row">
                                <div class="col-md-4">
                                    <DatePickerField
                                        v-model="form.start_date"
                                        name="start_date"
                                        label="Start Date"
                                        rules="required"
                                    />
                                </div>
                                <div class="col-md-4">
                                    <TimePickerField
                                        v-model="form.start_time"
                                        :value="form.start_time"
                                        name="start_time"
                                        label="Start Time"
                                        rules="required"
                                    />
                                </div>
                                <div class="col-md-4">
                                    <SelectField
                                        v-model="form.timezone"
                                        name="timezone"
                                        label="Time Zone"
                                        :options="timezones"
                                        :has-icon="true"
                                    >
                                        <template #append-icon>
                                            <a @click.prevent="() => {}">
                                                <i
                                                    class="fa fa-chevron-circle-down mt-2"
                                                    style="font-size: 20px; color: #40b8dc"
                                                />
                                            </a>
                                        </template>
                                    </SelectField>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <DatePickerField
                                        v-model="form.end_date"
                                        name="start_date"
                                        label="Start Date"
                                        rules="required"
                                    />
                                </div>
                                <div class="col-md-4">
                                    <TimePickerField
                                        v-model="form.end_time"
                                        name="end_time"
                                        label="End Time"
                                        rules="required"
                                    />
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <DatePickerField
                                v-model="form.start_date"
                                name="start_date"
                                label="Start Date"
                                rules="required"
                            />
                            <DatePickerField
                                v-model="form.end_date"
                                name="end_date"
                                label="End Date"
                                :disabled="disabledEndDate"
                            />
                        </div>

                        <TextareaField
                            v-model="form.about_short"
                            name="about_short"
                            label="About the Campaign - Short Description"
                            rules="required"
                            rows="5"
                            classWrapper="mb-4"
                        />
                        <TextareaField
                            v-model="form.about_campaign"
                            name="about_campaign"
                            label="Full Description"
                            rows="5"
                            classWrapper="mb-4"
                        />
                        <TextareaField
                            v-model="form.thankyou"
                            name="thankyou"
                            label="Thank You Note"
                            rules="required"
                            rows="5"
                            classWrapper="mb-4"
                        />
                    </div>

                    <div class="col-sm-12 col-md-5">
                        <TextField
                            v-model="form.goal_amount"
                            name="goal_amount"
                            label="Goal Amount"
                            rules="required|numeric"
                        />
                        <TextField
                            v-model="form.slam_amount"
                            name="slam_amount"
                            label="Slam Amount"
                            rules="required|numeric"
                        />

                        <div class="c-label">Amount Options</div>
                        <div class="row">
                            <div
                                class="col-6"
                                v-for="(option, index) in form.amount_options"
                                :key="index"
                            >
                                <TextField
                                    v-model="form.amount_options[index]"
                                    :name="`amount_options[${index}]`"
                                    :label="`Option ${index + 1}`"
                                />
                            </div>
                        </div>

                        <div class="c-label">Images</div>
                        <div class="c-upload">
                            <UploadImage
                                v-for="(image, index) in form.images"
                                :key="index"
                                v-model="form.images[index]"
                                :name="`images[${index}]`"
                                :removable="true"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </ValidationObserver>
</template>

<script>
import TextField from '@/commons/FormElements/TextField.vue';
import TextareaField from '@/commons/FormElements/TextareaField.vue';
import DatePickerField from '@/commons/FormElements/DatePickerField.vue';
import SelectField from '@/commons/FormElements/SelectField.vue';
import UploadImage from '@/commons/FormElements/UploadImage.vue';
import { TYPE_IDS } from './constants/index';
import DibbleJs from '@/dibble';
import DibbleApi from '@/api';
import TimePickerField from "@/commons/FormElements/TimePickerField.vue";

export default {
    name: 'CreateView',
    components: {
        TimePickerField,
        TextField,
        TextareaField,
        SelectField,
        UploadImage,
        DatePickerField,
    },
    data() {
        return {
            campaign: null,
            form: {
                type: '',
                title: '',
                start_date: '',
                start_time: '',
                end_date: '',
                end_time: '',
                timezone: '',
                about_short: '',
                about_campaign: '',
                thankyou: '',
                goal_amount: '',
                amount_options: ['', '', '', '', '', ''],
                slam_amount: '',
                images: ['', '', ''],
            },
            types: [],
            timezones: [],
        };
    },
    watch: {
        campaign(value) {
            for (const id in value.types) {
                this.types.push({
                    value: id,
                    label: this.campaign.types[id],
                });
            }
        },
    },
    computed: {
        disabledEndDate() {
            return this.form.type === TYPE_IDS.ON_GOING;
        },
    },
    created() {
        this.getTimezoneList();
        this.getData();
    },
    methods: {
        getData() {
            DibbleJs.showLoader();
            const data = {
                '#request': DibbleApi.api.getCampaign,
                campaign_id: this.$route.params.id,
            };
            DibbleJs.callApiRequest(data, (response) => {
                if (DibbleApi.isResponseSuccess(response)) {
                    this.campaign = response;
                    this.form = {
                        type: response.type.toString(),
                        title: response.title,
                        start_date: this.$moment(response.start_date).format(
                            'MM/DD/YYYY'
                        ),
                        start_time: response.event_start_time,
                        timezone: response.event_time_zone,
                        end_date: response.end_date
                            ? this.$moment(response.end).format('MM/DD/YYYY')
                            : '',
                        end_time: response.event_end_time,
                        about_short: response.about_short,
                        about_campaign: response.about_campaign,
                        thankyou: response.thankyou,
                        goal_amount: response.goal_amount.toString(),
                        amount_options: response.amount_options,
                        slam_amount: response.slam_amount.toString(),
                        images: response.images,
                    };

                    if (this.form.amount_options.length < 6) {
                        for (
                            let i = this.form.amount_options.length;
                            i < 6;
                            i++
                        ) {
                            this.form.amount_options.push('');
                        }
                    }

                    if (this.form.images.length < 3) {
                        for (let i = this.form.images.length; i < 3; i++) {
                            this.form.images.push('');
                        }
                    }
                } else {
                    DibbleJs.toastErrorMessage(response.message);
                }
                DibbleJs.hideLoader();
            });
        },
        goToViewCampaign() {
            this.$router.push({
                name: 'CampaignsView',
                params: {
                    id: this.$route.params.id,
                },
            });
        },
        getTimezoneList() {
            const params = {
                '#request': DibbleApi.api.getTimezoneList,
            }
            DibbleJs.callApiRequest(params, (response) => {
                console.log('timezone response', response)
                if (DibbleApi.isResponseSuccess(response)) {
                    for (const timezone in response.time_zones) {
                        this.timezones.push({
                            value: timezone,
                            label: response.time_zones[timezone],
                        })
                    }
                } else {
                    DibbleJs.toastErrorMessage(response.message);
                }
            })
        },
        onSubmit() {
            const amount_options = [];
            this.form.amount_options.forEach((option) => {
                if (option) {
                    amount_options.push(option);
                }
            });
            if (amount_options.length === 0) {
                DibbleJs.toastErrorMessage(
                    'At least one amount option is required.'
                );
                return;
            }

            const images = [];
            this.form.images.forEach((image) => {
                if (image) {
                    images.push(image);
                }
            });
            if (images.length === 0) {
                DibbleJs.toastErrorMessage('At least one image is required.');
                return;
            }

            DibbleJs.showLoader();
            const data = {
                '#request': DibbleApi.api.updateCampaign,
                campaign_id: this.$route.params.id,
                ...this.form,
                amount_options: amount_options.join(', '),
                goal_amount: Number(this.form.goal_amount),
                slam_amount: Number(this.form.slam_amount),
                type: Number(this.form.type),
                images: images.map((image) => ({
                    image,
                })),
            };


            if (this.form.start_time) {
                data.event_start_time = this.form.start_time;
            }

            if (this.form.end_time) {
                data.event_end_time = this.form.end_time;
            }

            if (this.form.timezone) {
                data.event_time_zone = this.form.timezone;
                data.event_time_zone_name = this.timezones.find((timezone) => timezone.value === data.event_time_zone).label;
            }

            DibbleJs.callApiRequest(data, (response) => {
                if (DibbleApi.isResponseSuccess(response)) {
                    DibbleJs.toastSuccessMessage(
                        'Update campaign successfully'
                    );
                    this.$router.push({
                        name: 'CampaignsView',
                        params: {
                            id: this.$route.params.id,
                        },
                    });
                } else {
                    DibbleJs.toastErrorMessage(response.message);
                }
                DibbleJs.hideLoader();
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.c-title {
    color: #2178ab;
    font-size: 22px;
    font-weight: 700;
}
.c-cancel-btn {
    border-radius: 20px;
    background: #d9d9d9;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
    font-size: 20px;
    font-weight: 700;
    width: 120px;
    color: #555e67;
    line-height: 140%;
}
.c-save-btn {
    border-radius: 20px;
    background: #2178ab;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
    font-size: 20px;
    font-weight: 700;
    color: #fff;
    width: 120px;
    line-height: 140%;
}
.c-label {
    font-size: 20px;
    line-height: 24px;
    color: #555e67;
    margin-top: 33px;
    margin-bottom: 33px;
}
.c-upload {
    background-color: #e1e7e9;
    border-radius: 20px;
    padding: 24px 32px;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
}
</style>
